import { createAsyncThunk } from '@reduxjs/toolkit';

import { getErrorMessage } from '@/shared/utils/error';
import type {
  EscritorioMembro,
  ListarMembrosFilters,
  UpdatePapelDto,
} from '@/types/escritorio/escritorioTypes';

import { membrosTenantService } from './services';

export const listarMembrosDoTenant = createAsyncThunk<
  EscritorioMembro[],
  { escritorioId: string; filters?: ListarMembrosFilters },
  { rejectValue: string }
>('adminGeral/membrosTenant/listar', async ({ escritorioId, filters }, { rejectWithValue }) => {
  try {
    return await membrosTenantService.listar(escritorioId, filters);
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Erro ao listar membros do escritório'));
  }
});

export const atualizarPapelMembroDoTenant = createAsyncThunk<
  EscritorioMembro,
  { escritorioId: string; membroId: string; papel: UpdatePapelDto['papel'] },
  { rejectValue: string }
>(
  'adminGeral/membrosTenant/atualizarPapel',
  async ({ escritorioId, membroId, papel }, { rejectWithValue }) => {
    try {
      return await membrosTenantService.atualizarPapel(escritorioId, membroId, papel);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Erro ao atualizar o papel do membro'));
    }
  },
);

export const removerMembroDoTenant = createAsyncThunk<
  void,
  { escritorioId: string; membroId: string },
  { rejectValue: string }
>('adminGeral/membrosTenant/remover', async ({ escritorioId, membroId }, { rejectWithValue }) => {
  try {
    await membrosTenantService.remover(escritorioId, membroId);
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Erro ao remover o membro do escritório'));
  }
});
